const service = {
  bannerVendorIdPropertyName: 'bannerVendorId',
};

export default service;
